package com.klantenstop.web.pages.admin.curatedcities

import com.klantenstop.web.data.models.domain.CuratedCity
import com.klantenstop.web.data.models.domain.Province
import com.klantenstop.web.utils.MVI

interface CuratedCitiesContract : MVI<CuratedCitiesContract.State, CuratedCitiesContract.Intent, CuratedCitiesContract.Effect> {

    data class State(
        val curatedCities: List<CuratedCity> = emptyList(),
        val isLoading: Boolean = false,
        val curatedCityToDelete: CuratedCity? = null
    ) {
        // Grouped and sorted by province (display name), then by whatever order the backend returned (featured on top)
        val groupedByProvince: Map<Province, List<CuratedCity>>
            get() = curatedCities
                .groupBy { it.province }
                .toList()
                .sortedBy { (province, _) -> province.displayName }
                .toMap()
    }

    sealed class Intent {
        data object LoadCuratedCities : Intent()
        data class DeleteCuratedCity(val curatedCityId: String) : Intent()
        data class SetCuratedCityToDelete(val curatedCity: CuratedCity?) : Intent()
        data class NavigateToManage(val curatedCityId: String? = null) : Intent()
    }

    sealed class Effect {
        data class NavigateToManage(val curatedCityId: String? = null) : Effect()
        data class ShowError(val message: String) : Effect()
        data class ShowSuccess(val message: String) : Effect()
    }
}
